import styled from 'styled-components'
import themeAssetloadingSquareLoadingSvg from '@theme/loading/square-loading.svg'

export const Image = styled.img`
  width: 100%;
  height: 2.393rem;
  background: url(${themeAssetloadingSquareLoadingSvg}) no-repeat center;
  background-size: cover;
  transition: background 0.2s ease-in;
`
